import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  .MuiIconButton-root:hover {
    background-color: rgba(199, 209, 218, 0.4);
  }

  /* Ensure Tailwind utilities work with Material-UI */
  .MuiButton-root {
    text-transform: none;
  }

  /* Custom utility classes that work with both Tailwind and Material-UI */
  .text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
